import moment from 'moment'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import {
  getOrders,
  getOrderDetails,
  cancelOrder,
  getFutureOrders,
  updateOrderAddress,
  updateOrderTime,
  cancelDelivery,
  createDelivery,
} from 'api/orderhistory'
import actions from './actions'

export function* GET_ORDERS(payload) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })
  const { response } = yield call(getOrders, payload)
  const { orders } = response.data
  yield put({
    type: actions.SET_STATE,
    payload: {
      data: orders,
      loading: false,
    },
  })
}

export function* GET_ORDER_DETAILS({ payload }) {
  const { response } = yield call(getOrderDetails, payload)
  const { order, isNew = true } = response.data
  yield put({
    type: actions.SET_STATE,
    payload: {
      selectedData: order,
      isNew,
    },
  })
}

export function* GET_FUTURE_ORDERS(data) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })
  const { response } = yield call(getFutureOrders, data.payload)
  const { orders } = response.data
  yield put({
    type: actions.SET_STATE,
    payload: {
      data: orders,
      loading: false,
    },
  })
}

export function* CANCEL_ORDER({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
      cancel: true,
    },
  })

  const { response } = yield call(cancelOrder, payload.order.id)

  const { order } = response.data

  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
      cancel: false,
      selectedData: order,
    },
  })
  if (payload.display) {
    yield call(
      GET_FUTURE_ORDERS,
      {
        payload: {
          from: moment(payload.dateValue.sdate).format('YYYY-MM-DD'),
          to: moment(payload.dateValue.edate).format('YYYY-MM-DD'),
          order_type: payload.display === 'List' ? payload.orderType : '',
          payment_type: payload.display === 'List' ? payload.paymentStatus : '',
        }
      }
    )
  } else {
    yield call(
      GET_ORDERS,
      {
        payload: {
          from: moment(payload.dateValue.sdate).format('YYYY-MM-DD'),
          to: moment(payload.dateValue.edate).format('YYYY-MM-DD'),
        }
      }
    )
  }
}

export function* UPDATE_ORDER_ADDRESS({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
      updating: true,
    },
  })
  const data = {
    address: payload?.address,
    ...(payload?.apartment_suite_no ? { apartment_suite_no: payload?.apartment_suite_no } : {}),
    ...(payload?.buzzer_code ? { buzzer_code: payload?.buzzer_code } : {}),
  }
  try {
    const { response } = yield call(updateOrderAddress, payload.orderId, data)

    const { order } = response.data

    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
        updating: false,
        selectedData: order,
      },
    })
    yield call(
      GET_ORDERS,
      {
        payload: {
          from: moment(payload.dateValue.sdate).format('YYYY-MM-DD'),
          to: moment(payload.dateValue.edate).format('YYYY-MM-DD'),
        }
      }
    )
  } catch (err) {
    console.log(err);
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
        updating: false,
      },
    })
  }
}

export function* UPDATE_ORDER_TIME({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
      updating: true,
    },
  })
  const data = {
    scheduled_at: payload?.scheduled_at,
  }

  try {
    const { response } = yield call(updateOrderTime, payload.orderId, data)

    const { order } = response.data

    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
        updating: false,
        selectedData: order,
      },
    })
    yield call(
      GET_ORDERS,
      {
        payload: {
          from: moment(payload.dateValue.sdate).format('YYYY-MM-DD'),
          to: moment(payload.dateValue.edate).format('YYYY-MM-DD'),
        }
      }
    )
  } catch (err) {
    console.log(err);
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
        updating: false,
      },
    })
  }
}

export function* CANCEL_DELIVERY({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
      delivery: true,
    },
  })

  const { response } = yield call(cancelDelivery, payload.order_id)

  const { order } = response.data

  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
      delivery: false,
      selectedData: order,
    },
  })
}

export function* CREATE_DELIVERY({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
      delivery: true,
    },
  })

  const { response } = yield call(createDelivery, payload.order_id)

  const { order } = response.data

  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
      delivery: false,
      selectedData: order,
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeLatest(actions.GET_ORDERS, GET_ORDERS),
    takeLatest(actions.GET_ORDER_DETAILS, GET_ORDER_DETAILS),
    takeLatest(actions.CANCEL_ORDER, CANCEL_ORDER),
    takeLatest(actions.GET_FUTURE_ORDERS, GET_FUTURE_ORDERS),
    takeLatest(actions.UPDATE_ORDER_ADDRESS, UPDATE_ORDER_ADDRESS),
    takeLatest(actions.UPDATE_ORDER_TIME, UPDATE_ORDER_TIME),
    takeLatest(actions.CANCEL_DELIVERY, CANCEL_DELIVERY),
    takeLatest(actions.CREATE_DELIVERY, CREATE_DELIVERY),
  ])
}
